import axios from 'lib/axios'

export interface CompanyUser {
  id: number
  person_id: number
  first_name: string
  last_name: string
  document: string | null
  email: string | null
  company_id: number
  requisition_code: string | null
  active: boolean
  role: string
  evaluated: boolean
  process_id: number | null
}

export type EvaluationFilter = 'all' | 'evaluated' | 'not_evaluated'
export type CompanyUsersFilter = EvaluationFilter | 'administrators' | 'leader_administrators'

interface CompanyUsersResponse {
  status: 'OK'
  data: {
    users: CompanyUser[]
    total_results: number
    total_pages: number
    page: number
    limit: number
  }
}

export const listCompanyUsers = async (
  companyId: number,
  page: number,
  filter: CompanyUsersFilter,
  processId: number | 'none' | undefined,
  search: string
) => {
  const response = await axios.get<CompanyUsersResponse>(`/company/${companyId}/users`, {
    params: {
      page,
      limit: 10,
      evaluation: filter === 'administrators' || filter === 'leader_administrators' ? 'all' : filter,
      ...(filter === 'administrators' || filter === 'leader_administrators' ? { roleGroup: filter } : {}),
      ...(processId && { processId }),
      ...(search && { search }),
    },
  })
  return response.data.data
}
